export const testData = () => {
  return {
    "count": 38,
    "next": null,
    "previous": null,
    "results": [
        {
            "id": 92107,
            "created_at": "2025-06-04 15:15:53",
            "sentiment": "Neutral",
            "description": "Корпоративные казначейства все чаще вкладывают в Bitcoin, теперь владея более 3% от общего количества, и больше шестидесяти фирм удвоили свои запасы за пару месяцев. Это говорит о растущем доверии бизнеса к криптовалюте и возможном подъеме ее ценности. В то же время, известный скептик Peter Schiff категорически заявляет, что Bitcoin не заменит золото и считает его обманом. В интервью на мероприятии Bitcoin 2025 он подробно объясняет свои опасения о будущем этой валюты. Такие противоречивые мнения подчеркивают, что мир криптовалют полон споров и разных точек зрения. В итоге, это обсуждение показывает как положительные тенденции, так и серьезные сомнения.",
            "coin": {
                "api_id": 1,
                "symbol": "BTC",
                "name": "Bitcoin",
                "slug": "bitcoin",
                "rank": 1,
                "price_usd": "105224.64",
                "market_cap": "$2.09T",
                "change_1d_usd": "-0.86%",
                "change_1w_usd": "-1.93%",
                "change_1m_usd": "10.33%",
                "high_1y_usd": "111016.53",
                "low_1y_usd": "51253.21",
                "twitter": "https://twitter.com/Bitcoin",
                "image": "https://static.images.dropstab.com/images/bitcoin.svg"
            },
            "tweet_count": 25,
            "mindshare_percent": 100.0,
            "mindshare_direction": "up",
            "total_positive_tweets_count": 23,
            "total_negative_tweets_count": 2,
            "total_positive_tweets_sum": 61181.56425321214,
            "total_negative_tweets_sum": 5537.897796095554
        },
        {
            "id": 92072,
            "created_at": "2025-06-04 09:15:30",
            "sentiment": "Positive",
            "description": "Слухи о сотрудничестве Magic Eden с Дональдом Трампом быстро подняли цену токена ME на 25 процентов, за что многие в сообществе были благодарны. Хотя сыновья Трампа вскоре опровергли эти новости, энтузиазм не угас и люди начали обсуждать возможный дальнейший рост. В твитах мелькают графики, показывающие бычий тренд и потенциальное удвоение цены в ближайшие недели. Один пользователь рассказал, как он вложился в токен на основе этих новостей и не жалеет, несмотря на разочарование. Он даже обещает довести дело до 2800 долларов и отблагодарить тех, кто поддержал его. В итоге, такие разговоры полны оптимизма и веры в будущее проекта.",
            "coin": {
                "api_id": 91699,
                "symbol": "ME",
                "name": "Magic Eden",
                "slug": "magic-eden",
                "rank": 280,
                "price_usd": "1.03",
                "market_cap": "$154.3M",
                "change_1d_usd": "19.43%",
                "change_1w_usd": "9.04%",
                "change_1m_usd": "9.87%",
                "high_1y_usd": "5.67",
                "low_1y_usd": "0.77",
                "twitter": "https://x.com/MagicEden",
                "image": "https://static.images.dropstab.com/images/magic-eden.jpg"
            },
            "tweet_count": 17,
            "mindshare_percent": 68.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 11,
            "total_negative_tweets_count": 6,
            "total_positive_tweets_sum": 2787.1706294057635,
            "total_negative_tweets_sum": 1560.4325574018108
        },
        {
            "id": 92154,
            "created_at": "2025-06-04 15:25:46",
            "sentiment": "Positive",
            "description": "Mask Network уверенно держится на уровне 10 миллионов после пика в 24,6 миллиона, что говорит о его стабильности в мире криптовалют. Многие задаются вопросом, сможет ли токен снова достичь своих рекордных высот, и это добавляет интриги к его будущему. В это же время сообщество вокруг проекта быстро набирает обороты, уже собралось более 4 тысяч членов всего за неделю. Такое быстрое развитие впечатляет, особенно если сравнивать с другими мемами, которые даже при больших капитализациях не достигают таких показателей. Возможно, это первый признак серьезного потенциала, и люди видят в нем сигнал для роста. Обсуждения в твитах подчеркивают общий интерес к тому, как проект развивается.",
            "coin": {
                "api_id": 25059,
                "symbol": "MASK",
                "name": "Mask Network",
                "slug": "mask-network",
                "rank": 183,
                "price_usd": "2.85",
                "market_cap": "$285.1M",
                "change_1d_usd": "1.98%",
                "change_1w_usd": "29.93%",
                "change_1m_usd": "159.92%",
                "high_1y_usd": "4.61",
                "low_1y_usd": "0.98",
                "twitter": "https://twitter.com/realMaskNetwork",
                "image": "https://static.images.dropstab.com/images/mask-network.svg"
            },
            "tweet_count": 14,
            "mindshare_percent": 56.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 13,
            "total_negative_tweets_count": 1,
            "total_positive_tweets_sum": 7335.121106930377,
            "total_negative_tweets_sum": 4.47213595499958
        },
        {
            "id": 92133,
            "created_at": "2025-06-04 15:21:19",
            "sentiment": "Positive",
            "description": "Цена $INJ развивается точно по прогнозам, с притоком средств в экосистему и снижением доминирования Bitcoin. За последние сутки туда влилось 110 миллионов долларов, что сигнализирует о растущем интересе. Партнерство с KaitoAI вызвало настоящий ажиотаж, даже сломав платформу, и видео с этим событием добавляет позитива. Технический анализ показывает, что валюта отскочила от сопротивления и укрепилась, намекая на возможный прорыв к 20 долларам. Не стоит упускать эту возможность, ведь следующие недели обещают быть динамичными и выгодными для держателей.",
            "coin": {
                "api_id": 22597,
                "symbol": "INJ",
                "name": "Injective",
                "slug": "injective-protocol",
                "rank": 64,
                "price_usd": "12.8",
                "market_cap": "$1.28B",
                "change_1d_usd": "-0.07%",
                "change_1w_usd": "-12.58%",
                "change_1m_usd": "37.24%",
                "high_1y_usd": "34.47",
                "low_1y_usd": "6.87",
                "twitter": "https://twitter.com/Injective_",
                "image": "https://static.images.dropstab.com/images/injective-protocol.jpg"
            },
            "tweet_count": 6,
            "mindshare_percent": 24.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 5,
            "total_negative_tweets_count": 1,
            "total_positive_tweets_sum": 1771.270920406363,
            "total_negative_tweets_sum": 71.39327699440614
        },
        {
            "id": 92108,
            "created_at": "2025-06-04 15:16:06",
            "sentiment": "Positive",
            "description": "Vitalik Buterin перевел значительную сумму эфириума и USDC в проект RAILGUN, что привлекает внимание многих. Это движение подчеркивает активность ключевых фигур в экосистеме и может намекать на интересные разработки. В это же время эфириум стабильно держится в определенном ценовом диапазоне, готовясь к возможному прорыву. Многие верят, что скоро цена резко вырастет, вызвав настоящий взрыв на рынке. Такие новости добавляют позитива и энтузиазма среди участников сообщества.",
            "coin": {
                "api_id": 2,
                "symbol": "ETH",
                "name": "Ethereum",
                "slug": "ethereum",
                "rank": 2,
                "price_usd": "2661.41",
                "market_cap": "$321.29B",
                "change_1d_usd": "1.59%",
                "change_1w_usd": "1.03%",
                "change_1m_usd": "45.53%",
                "high_1y_usd": "4002.63",
                "low_1y_usd": "1421.2",
                "twitter": "https://twitter.com/ethereum",
                "image": "https://static.images.dropstab.com/images/ethereum.svg"
            },
            "tweet_count": 6,
            "mindshare_percent": 24.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 6,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 9736.937639178283,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92105,
            "created_at": "2025-06-04 15:15:28",
            "sentiment": "Positive",
            "description": "Криптовалюта Compound недавно демонстрирует впечатляющий рост, с резким приростом цены и большими объемами торгов. Пользователи отмечают значительные притоки токенов, которые могут запустить мощный подъем или другие рыночные изменения. В обсуждениях часто звучат оптимистичные прогнозы, например, о возможном росте до 90-100 долларов в ближайшие месяцы благодаря техническим прорывам и добавлению на биржи вроде Binance. Это связано с общим интересом к DeFi, где Compound играет ключевую роль в управлении и ферминге доходов. Кроме того, графики показывают перелом нисходящих тенденций, что вдохновляет трейдеров на новые ставки. В целом, такие обновления создают атмосферу ожидания и энтузиазма среди сообщества.",
            "coin": {
                "api_id": 20204,
                "symbol": "COMP",
                "name": "Compound",
                "slug": "compound",
                "rank": 139,
                "price_usd": "46",
                "market_cap": "$417.82M",
                "change_1d_usd": "2.01%",
                "change_1w_usd": "9.31%",
                "change_1m_usd": "15.57%",
                "high_1y_usd": "126.77",
                "low_1y_usd": "35.62",
                "twitter": "https://twitter.com/compoundfinance",
                "image": "https://static.images.dropstab.com/images/compound-governance-token.svg"
            },
            "tweet_count": 6,
            "mindshare_percent": 24.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 6,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 813.3195437438756,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92124,
            "created_at": "2025-06-04 15:19:24",
            "sentiment": "Positive",
            "description": "SEI делает другие сети такими как Solana выглядящими дорогими, потому что её комиссии всего 0.0003, в то время как у конкурентов они в 150 раз выше. Это позволяет SEI легко доминировать в мире криптовалют. Кроме того, SEI предлагает реальное время расчётов и низкие сборы для всех пользователей. Её инфраструктура идеально подходит для игр, финансов, социальных сетей и даже ИИ. В твитах звучит, что SEI – это не просто монета, а настоящий движок для экономики Web3. Люди в сообществе активно приветствуют такие новости, что добавляет позитива.",
            "coin": {
                "api_id": 51905,
                "symbol": "SEI",
                "name": "Sei",
                "slug": "sei-network",
                "rank": 73,
                "price_usd": "0.2",
                "market_cap": "$1.06B",
                "change_1d_usd": "-1.12%",
                "change_1w_usd": "-9.68%",
                "change_1m_usd": "-2.49%",
                "high_1y_usd": "0.71",
                "low_1y_usd": "0.14",
                "twitter": "https://twitter.com/SeiNetwork",
                "image": "https://static.images.dropstab.com/images/sei-network.svg"
            },
            "tweet_count": 5,
            "mindshare_percent": 20.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 5,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 1023.5805096011895,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92037,
            "created_at": "2025-06-04 03:21:13",
            "sentiment": "Positive",
            "description": "Криптовалюта Turbo будоражит умы пользователей, с энтузиастичными советами купить ее как можно скорее, чтобы не упустить выгодный момент. В то же время звучат предупреждения о возможной переоценке, где ее нарратив называют основанным на обмане по сравнению с другими проектами. Появляются забавные призывы не расслабляться и усилить меминг на следующий день, добавляя легкости в обсуждение. Сравнивают Turbo с инновационными мем-коинами, созданными с помощью ИИ, подчеркивая реальные различия в их основе. В итоге, такие разговоры создают смесь возбуждения и сомнений среди сообщества, где каждый ищет свой подход к инвестициям.",
            "coin": {
                "api_id": 49646,
                "symbol": "TURBO",
                "name": "Turbo",
                "slug": "turbo",
                "rank": 181,
                "price_usd": "0.0042",
                "market_cap": "$290.77M",
                "change_1d_usd": "-4.43%",
                "change_1w_usd": "-17.59%",
                "change_1m_usd": "-26.05%",
                "high_1y_usd": "0.01",
                "low_1y_usd": "0.0015",
                "twitter": "https://twitter.com/TurboToadToken",
                "image": "https://static.images.dropstab.com/images/turbo.jpeg"
            },
            "tweet_count": 5,
            "mindshare_percent": 20.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 4,
            "total_negative_tweets_count": 1,
            "total_positive_tweets_sum": 145.52236310721003,
            "total_negative_tweets_sum": 29.0516780926679
        },
        {
            "id": 92141,
            "created_at": "2025-06-04 15:22:59",
            "sentiment": "Positive",
            "description": "Недавно Kaito заключил партнерство с Injective, которое разожгло настоящий интерес в криптосообществе и даже вызвало бурю в соцсетях. Люди с энтузиазмом делятся видео, показывающими это событие, и обсуждают, как оно влияет на рынок. Кроме того, технология Magic Newton от Kaito предстает как надежный помощник для криптоинвесторов, автоматизирующий операции и обеспечивая полную конфиденциальность. Она работает с умными аккаунтами и специальными защитами, чтобы никто не мог вмешаться в ваши дела. Тем не менее, в разговорах упоминают падение цены Kaito, что наводит на размышления о волатильности. В целом, такие обсуждения подчеркивают потенциал роста и новые возможности, несмотря на временные трудности.",
            "coin": {
                "api_id": 100249,
                "symbol": "KAITO",
                "name": "Kaito",
                "slug": "kaito",
                "rank": 138,
                "price_usd": "1.73",
                "market_cap": "$418.57M",
                "change_1d_usd": "-6.94%",
                "change_1w_usd": "-21.28%",
                "change_1m_usd": "119.5%",
                "high_1y_usd": "2.75",
                "low_1y_usd": "0.69",
                "twitter": "https://x.com/KaitoAI",
                "image": "https://static.images.dropstab.com/images/kaito.jpg"
            },
            "tweet_count": 4,
            "mindshare_percent": 16.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 2,
            "total_positive_tweets_sum": 328.81914102690945,
            "total_negative_tweets_sum": 767.0977666084486
        },
        {
            "id": 92127,
            "created_at": "2025-06-04 15:20:03",
            "sentiment": "Positive",
            "description": "Keeta сейчас разрывает рынок, возвращая сезон на базу с огромным энтузиазмом. С прошлого месяца объемы торгов взлетели до невиданных высот, что явно указывает на растущий интерес. Автор твита с нетерпением ждет, что в ближайшие дни цены пойдут вверх, принося большие возможности. Это может стать отличным временем для тех, кто следит за криптовалютами. Такие моменты часто собирают вокруг себя активное сообщество, полное оптимизма.",
            "coin": {
                "api_id": 101045,
                "symbol": "KTA",
                "name": "Keeta",
                "slug": "keeta",
                "rank": 136,
                "price_usd": "1.05",
                "market_cap": "$421.8M",
                "change_1d_usd": "-2.87%",
                "change_1w_usd": "40.87%",
                "change_1m_usd": "821.27%",
                "high_1y_usd": "1.18",
                "low_1y_usd": "0.0071",
                "twitter": "https://twitter.com/keetanetwork",
                "image": "https://static.images.dropstab.com/images/keeta.jpg"
            },
            "tweet_count": 4,
            "mindshare_percent": 16.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 3,
            "total_negative_tweets_count": 1,
            "total_positive_tweets_sum": 2931.9293597947635,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92117,
            "created_at": "2025-06-04 15:17:57",
            "sentiment": "Positive",
            "description": "Кто-то по имени @1DesyDonald только что получил поздравление за точный прогноз цены на криптовалюту Maker. Его признали топовым экспертом на платформе Market Prophit, что подчеркивает ценность его анализа. Это событие направляет внимание на полезность рыночных прогнозов в мире крипто. Люди советуют заглянуть на сайт, чтобы изучить настроения, шум и другие данные. Такие обсуждения показывают, как сообщество ценит успешные предсказания и делится знаниями. В итоге, это создает позитивный настрой вокруг Maker как перспективной валюты.",
            "coin": {
                "api_id": 1095,
                "symbol": "MKR",
                "name": "Maker",
                "slug": "maker",
                "rank": 80,
                "price_usd": "1822.49",
                "market_cap": "$955.05M",
                "change_1d_usd": "-4.31%",
                "change_1w_usd": "7.72%",
                "change_1m_usd": "19.48%",
                "high_1y_usd": "3007.51",
                "low_1y_usd": "898.11",
                "twitter": "https://twitter.com/MakerDAO",
                "image": "https://static.images.dropstab.com/images/maker.png"
            },
            "tweet_count": 4,
            "mindshare_percent": 16.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 4,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 2082.6289357200058,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92106,
            "created_at": "2025-06-04 15:15:41",
            "sentiment": "Positive",
            "description": "Китайская компания Webus подала документы в SEC для сбора 300 миллионов долларов на планы с XRP и интеграцию платежей Ripple, что открывает новые горизонты для развития. В то же время Ripple представила отчет за 2024 год, где отметила свежие пожертвования в 21 миллион долларов и общий объем более 200 миллионов. Эти шаги показывают, как проект активно расширяется и привлекает внимание инвесторов. Связанные изображения, вероятно, подчеркивают графики роста и ключевые достижения. Такие новости могут вдохновить сообщество на большее участие и обсуждения. В итоге, Ripple выглядит уверенно на рынке, демонстрируя потенциал для будущего.",
            "coin": {
                "api_id": 14553,
                "symbol": "XRP",
                "name": "XRP",
                "slug": "ripple",
                "rank": 4,
                "price_usd": "2.25",
                "market_cap": "$132.03B",
                "change_1d_usd": "-0.26%",
                "change_1w_usd": "-0.7%",
                "change_1m_usd": "2.64%",
                "high_1y_usd": "3.29",
                "low_1y_usd": "0.4",
                "twitter": "https://twitter.com/Ripple",
                "image": "https://static.images.dropstab.com/images/ripple.svg"
            },
            "tweet_count": 4,
            "mindshare_percent": 16.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 4,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 5587.947771120524,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92178,
            "created_at": "2025-06-04 15:30:44",
            "sentiment": "Positive",
            "description": "Leemon Baird, основатель Hedera, с энтузиазмом рассказывает о том, как их распределённую технологию можно объединить с искусственным интеллектом. Он вспоминает свои ранние годы, когда работал над PhD по ИИ, особенно по обучению с подкреплением, и теперь видит, как всё это возвращается в круг. Это открывает двери для монетизации данных, которые люди смогут использовать в AI. В твите звучит возбуждение от перспектив, где Hedera играет ключевую роль в будущем технологий. Такие идеи показывают, как проект развивается и интегрируется с инновациями.",
            "coin": {
                "api_id": 4112,
                "symbol": "HBAR",
                "name": "Hedera",
                "slug": "hedera-hashgraph",
                "rank": 20,
                "price_usd": "0.17",
                "market_cap": "$7.18B",
                "change_1d_usd": "-2.49%",
                "change_1w_usd": "-7.41%",
                "change_1m_usd": "-3.95%",
                "high_1y_usd": "0.37",
                "low_1y_usd": "0.04",
                "twitter": "https://twitter.com/hedera",
                "image": "https://static.images.dropstab.com/images/hedera-hashgraph.svg"
            },
            "tweet_count": 3,
            "mindshare_percent": 12.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 3,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 211.70501739186278,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92156,
            "created_at": "2025-06-04 15:26:09",
            "sentiment": "Positive",
            "description": "Пользователь полностью вложился в Jasmycoin и считает это всем, что ему нужно прямо сейчас. Он только что получил место для ноды от Janction, и это обещает пассивный доход в ближайшие дни. Вчера вышла новая Jasmy App, которая, вероятно, упрощает взаимодействие с криптовалютой. А в пятницу, 6-го, ожидается запуск совместного проекта Jasmy с правительством, что звучит как настоящий прорыв. Такие новости подчеркивают активный рост и инновации в проекте. Изображение, скорее всего, иллюстрирует эти позитивные события, добавляя визуальный энтузиазм.",
            "coin": {
                "api_id": 24821,
                "symbol": "JASMY",
                "name": "JasmyCoin",
                "slug": "jasmycoin",
                "rank": 92,
                "price_usd": "0.01",
                "market_cap": "$736.73M",
                "change_1d_usd": "-3.26%",
                "change_1w_usd": "-12.41%",
                "change_1m_usd": "-6.18%",
                "high_1y_usd": "0.06",
                "low_1y_usd": "0.0089",
                "twitter": "https://twitter.com/JasmyMGT",
                "image": "https://static.images.dropstab.com/images/jasmycoin.svg"
            },
            "tweet_count": 3,
            "mindshare_percent": 12.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 1,
            "total_positive_tweets_sum": 147.80781351174085,
            "total_negative_tweets_sum": 101.43470806385751
        },
        {
            "id": 92147,
            "created_at": "2025-06-04 15:24:12",
            "sentiment": "Positive",
            "description": "Автор твита с воодушевлением предрекает рост цены токена OM до 0.6 долларов всего за неделю, что явно намекает на веру в успех криптовалюты. Чтобы разжечь интерес, он обещает раздать 30 токенов всем, кто оставит комментарий с минимумом лайков, превращая это в забавный вызов для сообщества. Такие акции не только мотивируют людей участвовать, но и подчеркивают общий энтузиазм вокруг проекта. Прикрепленное изображение, вероятно, добавляет визуальной поддержки, показывая графики или символы роста. В итоге, это создает атмосферу ожидания и позитива, где каждый может почувствовать себя частью чего-то большего. Такие обсуждения помогают укрепить веру в перспективы Mantra DAO и привлекать новых участников.",
            "coin": {
                "api_id": 21171,
                "symbol": "OM",
                "name": "MANTRA",
                "slug": "mantra-dao",
                "rank": 174,
                "price_usd": "0.32",
                "market_cap": "$311.77M",
                "change_1d_usd": "-3.55%",
                "change_1w_usd": "-16.75%",
                "change_1m_usd": "-18.11%",
                "high_1y_usd": "8.46",
                "low_1y_usd": "0.3",
                "twitter": "https://twitter.com/MANTRAOMniverse",
                "image": "https://static.images.dropstab.com/images/mantra-dao.png"
            },
            "tweet_count": 3,
            "mindshare_percent": 12.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 3,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 114.26490111053053,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92146,
            "created_at": "2025-06-04 15:23:59",
            "sentiment": "Positive",
            "description": "1inch предлагает продвинутый API для свопов, который упрощает торговлю на блокчейнах. С помощью алгоритма Pathfinder он автоматически находит самые выгодные маршруты обмена, распределяя сделки по разным DEX, таким как Uniswap или SushiSwap. Это позволяет экономить на газовых расходах и минимизировать потери от проскальзывания. Пользователи получают доступ к огромной ликвидности и прозрачным ценам, что делает процесс торговли быстрым и удобным. В итоге, 1inch становится надежным помощником для трейдеров, ботов и арбитражных систем, помогая им достигать лучших результатов без лишних хлопот.",
            "coin": {
                "api_id": 23993,
                "symbol": "1INCH",
                "name": "1inch",
                "slug": "1inch",
                "rank": 177,
                "price_usd": "0.22",
                "market_cap": "$301.85M",
                "change_1d_usd": "-0.92%",
                "change_1w_usd": "-5.53%",
                "change_1m_usd": "11.67%",
                "high_1y_usd": "0.56",
                "low_1y_usd": "0.15",
                "twitter": "https://twitter.com/1inch",
                "image": "https://static.images.dropstab.com/images/1inch.svg"
            },
            "tweet_count": 3,
            "mindshare_percent": 12.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 3,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 2133.2834051228224,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92109,
            "created_at": "2025-06-04 15:16:19",
            "sentiment": "Positive",
            "description": "Vitalik Buterin перевел крупную сумму USDC в проект RAILGUN, что подчеркивает интерес известных фигур к новым разработкам. TerraSwap недавно добавила пару LUNC/USDC, позволяя инвесторам легко покупать и продавать токены без посредников. Это нововведение поддерживается сообществом, которое предоставило средства для пула ликвидности. Такие шаги помогают стабилизировать рынок для LUNC, ведь USDC остается надежной монетой. В итоге, такие события показывают, как USDC укрепляет свою роль в криптомире.",
            "coin": {
                "api_id": 3134,
                "symbol": "USDC",
                "name": "USDC",
                "slug": "usd-coin",
                "rank": 7,
                "price_usd": "1",
                "market_cap": "$61.44B",
                "change_1d_usd": "0%",
                "change_1w_usd": "0%",
                "change_1m_usd": "-0.02%",
                "high_1y_usd": "1",
                "low_1y_usd": "1",
                "twitter": "https://twitter.com/circle",
                "image": "https://static.images.dropstab.com/images/usd-coin.svg"
            },
            "tweet_count": 3,
            "mindshare_percent": 12.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 3,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 2859.6406837838626,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92087,
            "created_at": "2025-06-04 09:18:52",
            "sentiment": "Positive",
            "description": "Кто-то только что сорвал куш, выиграл 679.05 монет Solana через проект под названием $BALL, и теперь не может прийти в себя от радости. Он буквально трясется от эмоций и делится своим шоком в каждом слове. Эта удача заставляет его восторженно хвалить технологию, называя её безумно крутой. Наверняка прикреплённое изображение показывает доказательство выигрыша, добавляя реализма истории. Такие моменты подчёркивают, насколько динамичным и захватывающим может быть мир криптовалют. В итоге, это вдохновляет других и оставляет только положительные впечатления.",
            "coin": {
                "api_id": 19067,
                "symbol": "SOL",
                "name": "Solana",
                "slug": "solana",
                "rank": 6,
                "price_usd": "156.88",
                "market_cap": "$81.98B",
                "change_1d_usd": "-3.07%",
                "change_1w_usd": "-7.91%",
                "change_1m_usd": "6.77%",
                "high_1y_usd": "270.39",
                "low_1y_usd": "102.43",
                "twitter": "https://twitter.com/solana",
                "image": "https://static.images.dropstab.com/images/solana.svg"
            },
            "tweet_count": 3,
            "mindshare_percent": 12.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 3,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 446.9600092025979,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92175,
            "created_at": "2025-06-04 15:30:05",
            "sentiment": "Negative",
            "description": "Этот токен Polygon Ecosystem застрял на уровне ниже 0,22 доллара и никак не хочет расти, что вызывает разочарование среди держателей. Многие уже заскучали от таких результатов, считая его бесполезным и неинтересным. Критика звучит в адрес его неспособности набрать импульс на рынке. Общее настроение подчеркивает слабость монеты, с эмодзи, выражающими грусть и отчаяние. Такие мнения рисуют картину, где инвестиции в него не оправдывают ожиданий.",
            "coin": {
                "api_id": 53800,
                "symbol": "POL",
                "name": "POL (ex-MATIC)",
                "slug": "polygon-ecosystem-token",
                "rank": 45,
                "price_usd": "0.22",
                "market_cap": "$2.28B",
                "change_1d_usd": "0.44%",
                "change_1w_usd": "-3.98%",
                "change_1m_usd": "-5.47%",
                "high_1y_usd": "0.74",
                "low_1y_usd": "0.16",
                "twitter": "https://twitter.com/0xPolygon",
                "image": "https://static.images.dropstab.com/images/polygon-ecosystem-token.svg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 0,
            "total_negative_tweets_count": 2,
            "total_positive_tweets_sum": 0.0,
            "total_negative_tweets_sum": 369.7880308541477
        },
        {
            "id": 92171,
            "created_at": "2025-06-04 15:29:15",
            "sentiment": "Negative",
            "description": "Кто-то в твиттере рассказал о своей тревожной попытке купить криптовалюту KET на бирже PharaohExchange, где его едва не взломали хакеры. Он хотел протестировать версию eKET, но столкнулся с серьезными рисками, которые могли стоить ему денег. К сожалению, другой человек уже не уберегся и потерял свои инвестиции из-за этой атаки. Теперь автор твита призывает всех посмотреть короткое видео, чтобы понять, как избежать подобных ловушек. Такие истории подчеркивают, насколько важно делиться опытом в сообществе криптовалют.",
            "coin": {
                "api_id": 97915,
                "symbol": "KET",
                "name": "Ket",
                "slug": "ket",
                "rank": 116,
                "price_usd": "0.55",
                "market_cap": "$552.4M",
                "change_1d_usd": "-4.36%",
                "change_1w_usd": "-3.19%",
                "change_1m_usd": "83.29%",
                "high_1y_usd": "0.62",
                "low_1y_usd": "0.0096",
                "twitter": "https://twitter.com/yellowcatdao",
                "image": "https://static.images.dropstab.com/images/ket.jpg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 1,
            "total_negative_tweets_count": 1,
            "total_positive_tweets_sum": 77.9743547584717,
            "total_negative_tweets_sum": 169.41074346097417
        },
        {
            "id": 92166,
            "created_at": "2025-06-04 15:28:13",
            "sentiment": "Positive",
            "description": "Майнинг QUBIC с помощью octa_space — это настоящий раз плюнь, всего один клик отделяет от начала. Не нужно никаких технических знаний или сложных настроек, всё продумано для удобства. Автор твита явно подогревает интерес, спрашивая, не пора ли стать оптимистом по поводу этой криптовалюты. Изображение, скорее всего, показывает этот лёгкий процесс, чтобы вдохновить на действие. В итоге, это выглядит как отличный способ окунуться в мир крипты без лишних хлопот, привлекающий новичков и энтузиастов.",
            "coin": {
                "api_id": 54524,
                "symbol": "QUBIC",
                "name": "Qubic",
                "slug": "qubic-network",
                "rank": 251,
                "price_usd": "0.0000015",
                "market_cap": "$174.78M",
                "change_1d_usd": "-1.89%",
                "change_1w_usd": "0.03%",
                "change_1m_usd": "4.52%",
                "high_1y_usd": "0.0000049",
                "low_1y_usd": "0.00000075",
                "twitter": "https://twitter.com/Qubic_Network",
                "image": "https://static.images.dropstab.com/images/qubic-network.jpg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 158.30312519456706,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92165,
            "created_at": "2025-06-04 15:28:02",
            "sentiment": "Positive",
            "description": "KaiaChain впечатляет своими масштабами, собирая больше 200 миллионов активных пользователей на платформе LINE, где уже запущено множество мини-приложений. Игроки активно тратят миллионы в токенах KAIA, что подчеркивает реальный интерес и делает эту цепочку одной из крупнейших в мире EVM. Недавно вышла игра Star Riser, которая предлагает отличную возможность для развлечений и заработка, и люди с удовольствием ею пользуются. Пользователи делятся историями о гладком обмене токенов и стейкинге, где легко выполнять ежедневные миссии и получать награды. Это создает ощущение надежности и вдохновляет повторять такие действия, укрепляя общую экосистему.",
            "coin": {
                "api_id": 14948,
                "symbol": "KAIA",
                "name": "Kaia",
                "slug": "kaia",
                "rank": 102,
                "price_usd": "0.11",
                "market_cap": "$658.87M",
                "change_1d_usd": "-3.06%",
                "change_1w_usd": "-1.02%",
                "change_1m_usd": "-3.07%",
                "high_1y_usd": "0.37",
                "low_1y_usd": "0.1",
                "twitter": "https://twitter.com/klaytn_official",
                "image": "https://static.images.dropstab.com/images/klay-token.png"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 223.2003267462102,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92162,
            "created_at": "2025-06-04 15:27:24",
            "sentiment": "Neutral",
            "description": "Недавно криптовалюта Popcat столкнулась с уровнем сопротивления, где цена не смогла подняться выше. Это совпадает с важной скользящей средней на четырехчасовом графике, что часто сигнализирует о возможных проблемах. Тем не менее, она держится выше среднего взвешенного значения цены, что добавляет оптимизма. Из-за этого есть реальный шанс на новую попытку прорыва в ближайшее время. В связанных изображениях, вероятно, показан график, иллюстрирующий эти уровни, чтобы помочь лучше понять динамику.",
            "coin": {
                "api_id": 56528,
                "symbol": "POPCAT",
                "name": "Popcat",
                "slug": "popcat",
                "rank": 160,
                "price_usd": "0.37",
                "market_cap": "$359.94M",
                "change_1d_usd": "-10.15%",
                "change_1w_usd": "-17.17%",
                "change_1m_usd": "-0.31%",
                "high_1y_usd": "2.02",
                "low_1y_usd": "0.13",
                "twitter": "https://twitter.com/Popcatsolana",
                "image": "https://static.images.dropstab.com/images/popcat.png"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 191.32815025566347,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92149,
            "created_at": "2025-06-04 15:24:36",
            "sentiment": "Positive",
            "description": "В тестнете Soul Protocol процесс взаимодействия с криптовалютой проходит очень просто и удобно. Сначала предоставляю USDC, чтобы начать, затем включаю коллатерал для обеспечения. Далее заимствую DAI и отслеживаю, как начисляются проценты, что помогает держать всё под контролем. Возвращаю DAI без каких-либо сложностей, а потом вывожу свой USDC обратно. Каждый шаг сопровождается ясными подсказками и обновлениями статуса, что делает всё прозрачным и понятным.",
            "coin": {
                "api_id": 14532,
                "symbol": "DAI",
                "name": "Dai",
                "slug": "dai",
                "rank": 27,
                "price_usd": "1",
                "market_cap": "$5.37B",
                "change_1d_usd": "-0.01%",
                "change_1w_usd": "0.02%",
                "change_1m_usd": "0.01%",
                "high_1y_usd": "1",
                "low_1y_usd": "1",
                "twitter": "https://twitter.com/makerDAO",
                "image": "https://static.images.dropstab.com/images/dai.svg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 127.49901960407382,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92148,
            "created_at": "2025-06-04 15:24:25",
            "sentiment": "Positive",
            "description": "В тестнете протокола я прошел простые шаги, начиная с поставки USDC для обеспечения. Затем включил коллатерал, чтобы всё работало гладко, и заимствовал DAI без лишних хлопот. Я следил за начислением процентов в реальном времени, что помогало держать всё под контролем. Когда настало время, я вернул DAI и вывел свой USDC, не тратя лишнего времени на размышления. Каждый этап сопровождался чёткими подсказками и обновлениями статуса, так что не возникало никаких недоразумений или путаницы.",
            "coin": {
                "api_id": 14573,
                "symbol": "DAI",
                "name": "Dai",
                "slug": "dai2",
                "rank": 53,
                "price_usd": "1.02",
                "market_cap": "$103.2M",
                "change_1d_usd": null,
                "change_1w_usd": null,
                "change_1m_usd": null,
                "high_1y_usd": null,
                "low_1y_usd": null,
                "twitter": null,
                "image": "https://static.icodrops.com/images/coin-default.png"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 127.49901960407382,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92145,
            "created_at": "2025-06-04 15:23:46",
            "sentiment": "Positive",
            "description": "Фонд Pi Network недавно перевел 50 миллионов токенов, что намекает на предстоящие изменения в сети. Многие видят в этом шаг к новому распределению, которое может привлечь больше участников. Это событие вызывает живой интерес, особенно с учетом эмоциональных эмодзи в обсуждениях. В связанных изображениях, вероятно, показаны графики или визуалы, подчеркивающие активность фонда. Обсуждения фокусируются на перспективах роста, делая тему еще более захватывающей для сообщества.",
            "coin": {
                "api_id": 100359,
                "symbol": "PI",
                "name": "Pi Network",
                "slug": "pi-network",
                "rank": 29,
                "price_usd": "0.65",
                "market_cap": "$4.77B",
                "change_1d_usd": "0.03%",
                "change_1w_usd": "-10.51%",
                "change_1m_usd": "10.19%",
                "high_1y_usd": "2.94",
                "low_1y_usd": "0.44",
                "twitter": "https://twitter.com/PiCoreTeam",
                "image": "https://static.images.dropstab.com/images/pi-network.jpg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 103.98692286128124,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92122,
            "created_at": "2025-06-04 15:19:00",
            "sentiment": "Positive",
            "description": "Ankr предлагает удобные инструменты, которые упрощают создание приложений, заработок и развлечения на блокчейне. С мощными RPC-эндпоинтами разработчики могут быстро реализовывать свои идеи, а пользователи наслаждаться процессом без лишних сложностей. Глобальная сеть узлов обеспечивает стабильность и высокую скорость, что делает всё ещё более надёжным. В твитах подчёркивается, как это открывает бесконечные перспективы для инноваций. Кроме того, Ankr охватывает сферы Web3, AI и DEPIN, помогая всем от новичков до профессионалов.",
            "coin": {
                "api_id": 3541,
                "symbol": "ANKR",
                "name": "Ankr",
                "slug": "ankr",
                "rank": 257,
                "price_usd": "0.02",
                "market_cap": "$170.2M",
                "change_1d_usd": "-0.25%",
                "change_1w_usd": "-4.31%",
                "change_1m_usd": "-5.83%",
                "high_1y_usd": "0.06",
                "low_1y_usd": "0.01",
                "twitter": "https://twitter.com/ankr",
                "image": "https://static.images.dropstab.com/images/ankr.svg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 179.15053542595598,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92104,
            "created_at": "2025-06-04 15:15:13",
            "sentiment": "Positive",
            "description": "ICON сейчас проходит через ретесты, что многие видят как шанс для выгодных покупок, так как цена может быстро пойти вверх. Инвесторы активно обсуждают бычий импульс, который подталкивает токен к росту. Один из пользователей решил открыть лонг позицию, опираясь на текущий funding rate в минус 0,5%, что сигнализирует о возможном большом шорт сквизе. Это несмотря на долгосрочный нисходящий тренд, который, по их мнению, вот-вот переломится. Такие мнения создают атмосферу ожидания подъема, где даже недавние спады воспринимаются как временные.",
            "coin": {
                "api_id": 25,
                "symbol": "ICX",
                "name": "ICON",
                "slug": "icon",
                "rank": 269,
                "price_usd": "0.15",
                "market_cap": "$161.57M",
                "change_1d_usd": "13.27%",
                "change_1w_usd": "28.23%",
                "change_1m_usd": "55.59%",
                "high_1y_usd": "0.28",
                "low_1y_usd": "0.08",
                "twitter": "https://twitter.com/@helloiconworld",
                "image": "https://static.images.dropstab.com/images/icon.svg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 219.09269781747406,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92098,
            "created_at": "2025-06-04 12:20:05",
            "sentiment": "Positive",
            "description": "В твитах упоминают, как ApeCoin достигает ключевых уровней сопротивления и может преодолеть их при подходящих условиях. Обсуждают его положение относительно USDT и BTC, где токен показывает стабильность. Появляется информация о сотрудничестве с известными платформами, что подчеркивает его роль среди других активов. Люди отмечают потенциал роста, если цена останется выше определенных индикаторов, и сравнивают с похожими токенами для оценки перспектив.",
            "coin": {
                "api_id": 39316,
                "symbol": "APE",
                "name": "ApeCoin",
                "slug": "apecoin",
                "rank": 117,
                "price_usd": "0.73",
                "market_cap": "$549.96M",
                "change_1d_usd": "5.18%",
                "change_1w_usd": "4.26%",
                "change_1m_usd": "48.21%",
                "high_1y_usd": "2.09",
                "low_1y_usd": "0.38",
                "twitter": "https://twitter.com/apecoin",
                "image": "https://static.images.dropstab.com/images/apecoin-1.svg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 1,
            "total_negative_tweets_count": 1,
            "total_positive_tweets_sum": 0.0,
            "total_negative_tweets_sum": 50.50742519669756
        },
        {
            "id": 92093,
            "created_at": "2025-06-04 09:20:11",
            "sentiment": "Negative",
            "description": "MagicEden внезапно объявил о сотрудничестве с криптовалютой Trump для создания специального кошелька, но это быстро обернулось путаницей. Аккаунт проекта заблокировали, а Eric Trump публично отрицает любую связь и предупреждает о несанкционированном использовании имени. Автор твита видит в этом полный беспорядок, где крупная компания вроде MagicEden вряд ли бы распространяла ложные новости, но репутация уже пострадала. Возможно, все было согласовано, но информация не дошла до ключевых фигур, что само по себе кажется странным. В итоге, если ситуация разрешится positively, это могло бы стать настоящим прорывом для экосистемы Bitcoin, включая руны и ординалы.",
            "coin": {
                "api_id": 97592,
                "symbol": "TRUMP",
                "name": "Official Trump",
                "slug": "official-trump",
                "rank": 46,
                "price_usd": "11.02",
                "market_cap": "$2.2B",
                "change_1d_usd": "-2.39%",
                "change_1w_usd": "-10.02%",
                "change_1m_usd": "-0.54%",
                "high_1y_usd": "71.9",
                "low_1y_usd": "7.37",
                "twitter": "https://twitter.com/realDonaldTrump",
                "image": "https://static.images.dropstab.com/images/official-trump.jpg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 1,
            "total_negative_tweets_count": 1,
            "total_positive_tweets_sum": 2768.948898047777,
            "total_negative_tweets_sum": 697.674709302265
        },
        {
            "id": 92085,
            "created_at": "2025-06-04 09:18:26",
            "sentiment": "Positive",
            "description": "GIGA предстает как идеально сконструированная монета, которая вызывает настоящее восхищение. Автор не может поверить, что такая возможность была так легко доступна. Но они не колебались и решили её использовать. Это подчеркивает огромный потенциал, который видят в этой криптовалюте. В обсуждениях звучит уверенность в её будущем. Возможно, видео добавляет визуальные подтверждения этим мыслям.",
            "coin": {
                "api_id": 59060,
                "symbol": "GIGA",
                "name": "Gigachad",
                "slug": "gigachad",
                "rank": 213,
                "price_usd": "0.02",
                "market_cap": "$225.12M",
                "change_1d_usd": "-5.15%",
                "change_1w_usd": "9.07%",
                "change_1m_usd": "34.39%",
                "high_1y_usd": "0.09",
                "low_1y_usd": "0.0015",
                "twitter": "https://x.com/GIGACHAD_meme",
                "image": "https://static.images.dropstab.com/images/gigachad-2.jpeg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 695.0118460561927,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92083,
            "created_at": "2025-06-04 09:18:01",
            "sentiment": "Positive",
            "description": "Топ гейнеров криптовалют за последние 24 часа возглавляют перспективные проекты, среди которых выделяется cow-protocol с приростом цены в 8.69%. Это делает его вторым в списке, что говорит о растущем интересе инвесторов и позитивных рыночных тенденциях. Такие показатели часто вдохновляют сообщество на обсуждения и новые инвестиции, подчеркивая успешность проекта. В целом, рост cow-protocol на фоне других валют вроде RKT и MKR демонстрирует общий подъем в секторе. Возможно, это связано с текущими рыночными динамиками, которые благоприятно влияют на такие активы.",
            "coin": {
                "api_id": 39596,
                "symbol": "COW",
                "name": "CoW Protocol",
                "slug": "cow-protocol",
                "rank": 226,
                "price_usd": "0.43",
                "market_cap": "$203.01M",
                "change_1d_usd": "2.46%",
                "change_1w_usd": "-0.46%",
                "change_1m_usd": "51.8%",
                "high_1y_usd": "1.16",
                "low_1y_usd": "0.16",
                "twitter": "https://twitter.com/CoWSwap",
                "image": "https://static.images.dropstab.com/images/cow-protocol.png"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 502.51666645191233,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92080,
            "created_at": "2025-06-04 09:17:21",
            "sentiment": "Positive",
            "description": "Улицы сейчас явно нуждаются в большом стимуле от криптовалюты Grass, чтобы поднять настроение и помочь в делах. Это звучит как искренний призыв к действию, где люди выражают надежду на ее полезность в повседневной жизни. Такие упоминания подчеркивают, что Grass видят как инструмент для быстрой поддержки. В общем, это добавляет тепла к обсуждениям, показывая энтузиазм и веру в ее возможности. Активный тон говорит о том, что сообщество ждет положительных перемен от нее.",
            "coin": {
                "api_id": 79226,
                "symbol": "GRASS",
                "name": "Grass",
                "slug": "grass",
                "rank": 115,
                "price_usd": "1.93",
                "market_cap": "$554.6M",
                "change_1d_usd": "6.99%",
                "change_1w_usd": "-12.53%",
                "change_1m_usd": "30.97%",
                "high_1y_usd": "3.75",
                "low_1y_usd": "0.75",
                "twitter": "https://x.com/getgrass_io",
                "image": "https://static.images.dropstab.com/images/grass.png"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 1,
            "total_negative_tweets_count": 1,
            "total_positive_tweets_sum": 340.19700175045637,
            "total_negative_tweets_sum": 134.03357788255897
        },
        {
            "id": 92063,
            "created_at": "2025-06-04 03:26:36",
            "sentiment": "Positive",
            "description": "Инвесторы активно скупают Algorand по текущим ценам, видя в ней огромный потенциал. Автор твита уверен, что это самая выгодная покупка среди криптовалют. Он подчеркивает, что монета сильно недооценена, что может привести к росту цены в будущем. Такие мнения часто обсуждаются в сообществе, где люди делятся рыночными наблюдениями. Возможно, прилагаемое изображение показывает графики или позитивные тенденции, подкрепляя энтузиазм.",
            "coin": {
                "api_id": 3893,
                "symbol": "ALGO",
                "name": "Algorand",
                "slug": "algorand",
                "rank": 57,
                "price_usd": "0.2",
                "market_cap": "$1.68B",
                "change_1d_usd": "-3.07%",
                "change_1w_usd": "-9.4%",
                "change_1m_usd": "-3.31%",
                "high_1y_usd": "0.55",
                "low_1y_usd": "0.1",
                "twitter": "https://twitter.com/algorand",
                "image": "https://static.images.dropstab.com/images/algorand.jpg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 532.7794475887723,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92051,
            "created_at": "2025-06-04 03:24:12",
            "sentiment": "Positive",
            "description": "Пользователь делится, как добавил еще токенов VICTOR для стейкинга и теперь подходит ближе к своей цели. За месяц он накопил почти эквивалент одного EGLD, что выглядит как приятный результат. Это показывает, насколько выгодно инвестировать в такую крипту, особенно когда цена держится стабильной. В твите упоминается текущая стоимость, добавляя реализма к его истории. Общий тон полон энтузиазма, ведь автор явно доволен прогрессом и мотивирует других попробовать.",
            "coin": {
                "api_id": 21527,
                "symbol": "EGLD",
                "name": "MultiversX",
                "slug": "multivers-x",
                "rank": 129,
                "price_usd": "15.85",
                "market_cap": "$448.34M",
                "change_1d_usd": "-0.82%",
                "change_1w_usd": "-11.48%",
                "change_1m_usd": "1.64%",
                "high_1y_usd": "57.26",
                "low_1y_usd": "12.57",
                "twitter": "https://twitter.com/elrondnetwork",
                "image": "https://static.images.dropstab.com/images/multivers-x.svg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 59.46847804707254,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92047,
            "created_at": "2025-06-04 03:23:20",
            "sentiment": "Positive",
            "description": "В твиттере часто мелькают уверенные прогнозы о том, что цена Zencash пойдет вверх. Один пользователь прямо отвечает, что это случится без сомнений, подчеркивая свою уверенность. Такие слова звучат как сигнал к оптимизму среди инвесторов. Это может быть связано с общими трендами в криптомире, где каждый ищет признаки подъема. В итоге, подобные мнения укрепляют интерес к валюте и заставляют следить за новостями. Неудивительно, что такие обсуждения придают сил сообществу.",
            "coin": {
                "api_id": 14551,
                "symbol": "ZEN",
                "name": "Horizen",
                "slug": "zencash",
                "rank": 246,
                "price_usd": "11.24",
                "market_cap": "$180.52M",
                "change_1d_usd": "-2.55%",
                "change_1w_usd": "20.76%",
                "change_1m_usd": "34.25%",
                "high_1y_usd": "44.03",
                "low_1y_usd": "6.25",
                "twitter": "https://twitter.com/horizenglobal",
                "image": "https://static.images.dropstab.com/images/zencash.svg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 1,
            "total_negative_tweets_count": 1,
            "total_positive_tweets_sum": 189.94736112934027,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92043,
            "created_at": "2025-06-04 03:22:27",
            "sentiment": "Positive",
            "description": "Недавно в мире криптовалют появились отличные обновления для Quant Network. Поток монет на биржах перевернулся и показывает сильный отток, что многие воспринимают как бычий сигнал для роста. Цена поднялась до 113.78 долларов, а резерв в долларах увеличился на 7.79 процентов. Это указывает на то, что инвесторы активно накапливают актив. Общий настрой полон оптимизма, с призывами поддерживать текущий импульс. Возможно, это начало нового этапа для этой криптовалюты.",
            "coin": {
                "api_id": 2822,
                "symbol": "QNT",
                "name": "Quant",
                "slug": "quant-network",
                "rank": 61,
                "price_usd": "117.12",
                "market_cap": "$1.41B",
                "change_1d_usd": "4.65%",
                "change_1w_usd": "3.42%",
                "change_1m_usd": "35.33%",
                "high_1y_usd": "166.65",
                "low_1y_usd": "53.54",
                "twitter": "https://twitter.com/quant_network",
                "image": "https://static.images.dropstab.com/images/quant-network.svg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 76.55063683601855,
            "total_negative_tweets_sum": 0.0
        },
        {
            "id": 92033,
            "created_at": "2025-06-04 03:20:22",
            "sentiment": "Positive",
            "description": "Altcoins, включая Floki-Inu, вот-вот взорвутся с новой силой, как летний пузырь, и это добавляет адреналина в обсуждениях. В твитах подчеркивают, что консолидация заканчивается через 10-14 дней, открывая путь для резкого роста цены. Технический анализ показывает, что Floki-Inu в фазе клиновидной фигуры, которая обещает много пространства для подъема. Это связано с общей теорией о успешном лете в криптомире, где такие монеты могут блеснуть. Прикрепленное изображение, вероятно, подчеркивает эти тенденции, показывая графики с позитивными сигналами.",
            "coin": {
                "api_id": 28939,
                "symbol": "FLOKI",
                "name": "Floki Inu",
                "slug": "floki-inu",
                "rank": 86,
                "price_usd": "0.000085",
                "market_cap": "$816.28M",
                "change_1d_usd": "-3.52%",
                "change_1w_usd": "-15.48%",
                "change_1m_usd": "11.55%",
                "high_1y_usd": "0.00033",
                "low_1y_usd": "0.000048",
                "twitter": "https://twitter.com/realflokiinu",
                "image": "https://static.images.dropstab.com/images/floki-inu.svg"
            },
            "tweet_count": 2,
            "mindshare_percent": 8.0,
            "mindshare_direction": "down",
            "total_positive_tweets_count": 2,
            "total_negative_tweets_count": 0,
            "total_positive_tweets_sum": 804.9325511465057,
            "total_negative_tweets_sum": 0.0
        }
    ]
  }
}